module.exports = __webpack_public_path__ + "img/RedMCCard.1928e9e7.png";